<template>
  <div class="form-field">
    <label v-if="label">{{ label }}:</label>
    <v-select
      :options="options"
      :clearable="false"
      :searchable="false"
      :value="selectedValue"
      @input="emitSelectedValue"
    >
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes"><iconDropdown /></span>
      </template>
    </v-select>
  </div>
</template>

<script>
import iconDropdown from "@/components/Icons/iconDropdown";

export default {
  components: {
    iconDropdown
  },

  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },

    selectedValue: {
      type: Object
    }
  },

  methods: {
    emitSelectedValue(data) {
      this.$emit("selectedValue", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

label {
  font-size: 12px;
  line-height: 1;
  color: $white;
  text-transform: uppercase;
  margin-bottom: 10px;
}
</style>

<style lang="scss">
.vs__dropdown-toggle {
  border-radius: 0;
  border: 2px solid $white-40;
  background: $black-60;
  height: 50px;
  padding: 0;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: $yellow;
  }
}

.vs__selected {
  color: $white;
  opacity: 1;
}

.vs--single.vs--open {
  .vs__dropdown-toggle {
    border-color: $yellow;
  }
}

.vs--single.vs--open .vs__selected {
  opacity: 1;
  position: static;
}

.v-select.vs--open .vs__open-indicator {
  transform: none;
}
.vs__actions {
  padding: 0 14px 0 0;
}

.vs__selected-options {
  padding: 0;
}

.vs__selected {
  margin: 0;
  padding: 0 0 0 22px;
}

.vs__dropdown-menu {
  border-radius: 0;
  border: none;
  background: $dark-grey;
  margin: 0;
  padding: 0;
  top: 100%;
  overflow: visible;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    box-shadow: 0px 20px 10px 0px rgba(0, 0, 0, 0.6);
    z-index: -1;
  }
}

.vs__dropdown-menu .vs__dropdown-option {
  color: $white;
  opacity: 1;
  height: 50px;
  display: inline-flex;
  width: 100%;
  align-items: center;
}

.vs__dropdown-option--highlight {
  background: $graphite;
}

.vs__dropdown-menu .vs__dropdown-option.vs__dropdown-option--selected {
  display: none;
}
</style>
